import InlineSVG from '@boilerplates/inlineSvg'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs_23 = (props: RealEstateDataPageComponentData) => {
  const { paragraphs, button, titleColor, titleElement, title, paragraphColor } = props

  return (
    <section className="about-23 p-y-config">
      <Container fluid>
        <Row>
          {title && (
            <ElementHTML
              children={title}
              elementType={titleElement || 'h2'}
              className="mb-3 mb-lg-5"
              style={{ color: titleColor }}
            />
          )}
          {paragraphs?.map((paragraph) => (
            <ElementHTML
              children={paragraph}
              style={{ color: paragraphColor }}
              elementType={'p'}
              className="mb-3"
            />
          ))}
        </Row>
        <Row>
          {button?.file && (
            <a
              className={`btn btn-primary ms-2 mt-3 ${button?.border ? 'border' : ''}`}
              style={{ width: 'fit-content' }}
              target={'_blank'}
              href={button?.file}
            >
              {button?.value ?? ''}
              {button?.image &&
                (button?.isSvg ? (
                  <InlineSVG
                    src={button.image ?? ''}
                    className="file-icon ms-2"
                  />
                ) : (
                  <img
                    src={button.image}
                    className="file-icon ms-2"
                  />
                ))}
            </a>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs_23
